import {createSelector, createStructuredSelector} from 'helpers';
import * as session from 'store/session';

export const todayAdjustedToNight = createSelector(
  [session.today, session.isNight],
  (today, isNight) => isNight ? today.clone().subtract(1, 'day') : today
);

export const today = session.today;

export const tomorrow = createSelector(
  [today],
  (today) => today.clone().add(1, 'day')
);

export const yesterday = createSelector(
  [today],
  (today) => today.clone().subtract(1, 'day')
);

export const days = createStructuredSelector({today, tomorrow, yesterday});
